export default __webpack_public_path__ + "static/media/crypto055.7e2346c9.gif";